import BannerSection from "./BannerSection";
import TopicSection from "./TopicSection";
import SolutionSection from "./SolutionSection";
import SecondBannerSection from "./SecondBannerSection";
import WhyChooseSection from "./WhyChooseSection";
import CountSection from "./CountSection";
import CustomerSection from "./CustomerSection";

const HomePage = () => {
  return (
    <>
      <BannerSection />
      <TopicSection />
      <SolutionSection />
      <SecondBannerSection />
      <WhyChooseSection />
      <CountSection />
      <CustomerSection />
    </>
  );
};

export default HomePage;
